export default {
  // TITLE
  TitleControl: '',
  ShowTitleControl: { checked: true },
  StyleTitleControl: {
    fontSize: 20,
    color: '#000000',
    fontFamily: 'arial',
    bold: false,
    italic: false,
    underline: false,
    align: 'center',
  },
  // GENERAL
  SortValuesControl: 'Alfabética A-Z',
  CustomSortControl: {
    checked: false, kpiCategories: [],
  },
  ReverseControl: { checked: false },
  LayoutControl: 'horizontal',
  GroupModeControl: 'stacked',
  MetricTypeControl: 'bar',
  MeasureSizeControl: 0.4,
  MarkersSizeControl: 0.9,
  BarsPaddingControl: 30,
  Margin: {
    top: 50, right: 60, bottom: 55, left: 100,
  },
  MinValueControl: { value: 0, checked: true, pai: true },
  MaxValueControl: { value: 0, checked: true, pai: true },
  DataFormat: 'absolute', // { type: 'absolute', target: 'global' },
  DataPercentFormat: 'global',
  DataAbsoluteFormat: 'number',
  DurationUnit: 'hours',
  // STYLE
  ExtBorderWidthControl: 0,
  ExtBorderColorControl: { from: 'color', modifiers: [['darker', 1.6]] },
  IntBorderWidthControl: 0,
  IntBorderColorControl: { from: 'color', modifiers: [['darker', 1.6]] },
  MetricColorControl: '#f22',
  PalletsControl: 'default',
  ColorTheme: { scheme: 'nivo' },
  GradientPickerControl: {
    color1: '#4711B2',
    color2: '#FF9626',
    color3: null,
  },
  Colors: {},
  UseGlobalColor: true,
  UseGlobalFont: true,
  // LABEL
  LabelPositionControl: 'before',
  LabelColorControl: '#333333',
  LabelsFontFamilyControl: { value: 'sans-serif' },
  LabelsFontSizeControl: { value: 12 },
  LabelRotationControl: 0,
  LabelTranslateX: 0,
  LabelTranslateY: 0,
  // AXIS
  AxisPosition: 'after',
  AxisGlobal: {
    fontFamily: 'arial',
    fontSize: 12,
    legendFontSize: 12,
    color: '#333333',
  },
  AxisRotationControl: 0,
  AxisTranslateX: 0,
  AxisTranslateY: 0,
  // TOOLTIP / INTERACTIVE
  InteractiveControl: true,
  InteractiveFormat: 'size',
  InteractivePrefixControl: '',
  InteractiveSufixControl: '',
  InteractiveDecimals: 'auto',
  InteractiveSeparadorNumericoCasas: 0,
  InteractiveCurrencyControl: 'Nenhum',
  InteractiveGroupingControl: 'Nenhum',
  Animate: false,
  MotionConfig: 'default',
};
